import TextAnimate from '../../animation/TextAnimate'
import ImageAnimate from '../../animation/ImageAnimate'
import { Form, Button, Card, Accordion, Nav, Tab, FloatingLabel } from 'react-bootstrap'
import { BadgeCheck, Clock4, GitCommitHorizontal, MapPin, ChevronLeft, ChevronRight, Mail, PhoneCall } from 'lucide-react'
import { FaStar, FaArrowUp } from 'react-icons/fa'
import hero_img_1 from '../../assets/images/marathon.jpg'
import hero_img_2 from '../../assets/images/marathon1.jpg'
import Slider from "react-slick"
import about_img1 from '../../assets/images/about-img11.png'
import about_img2 from '../../assets/images/about-img12.png'
import about_img3 from '../../assets/images/about-img13.png'
import event_img1 from '../../assets/images/event-img7.png'
import memories_img_1 from '../../assets/images/fitness.jpg'
import memories_img_2 from '../../assets/images/wellbeing.jpg'
import memories_img_3 from '../../assets/images/nature.jpg'
import memories_img_4 from '../../assets/images/fund.jpg'
import memories_img_5 from '../../assets/images/knowledge.jpg'
import memories_img_6 from '../../assets/images/community.jpg'
import organizer_img_1 from '../../assets/images/brand-img1.png'
import organizer_img_2 from '../../assets/images/brand-img2.png'
import organizer_img_3 from '../../assets/images/brand-img3.png'
import organizer_img_4 from '../../assets/images/brand-img4.png'
import organizer_img_5 from '../../assets/images/brand-img5.png'
import organizer_img_6 from '../../assets/images/brand-img6.png'
import organizer_img_7 from '../../assets/images/brand-img7.png'
import organizer_img_8 from '../../assets/images/brand-img8.png'
import testimonial_img_1 from '../../assets/images/testimonial-img1.png'
import { useNavigate } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'
import Loader from '../../components/loader/Loader'
import moment from 'moment/moment'
import PerfectScrollbar from 'react-perfect-scrollbar'
import 'react-perfect-scrollbar/dist/css/styles.css'
import { categoryList } from '../../redux/slices/event/CategoryList'
import { eventByDate } from '../../redux/slices/event/EventByDate'

export const LandingPageImport = {
    TextAnimate,
    ImageAnimate,
    Form,
    Button,
    Card,
    Accordion,
    Nav,
    Tab,
    FloatingLabel,
    BadgeCheck,
    Clock4,
    GitCommitHorizontal,
    MapPin,
    ChevronLeft,
    ChevronRight,
    Mail,
    PhoneCall,
    FaStar,
    FaArrowUp,
    hero_img_1,
    hero_img_2,
    Slider,
    about_img1,
    about_img2,
    about_img3,
    event_img1,
    memories_img_1,
    memories_img_2,
    memories_img_3,
    memories_img_4,
    memories_img_5,
    memories_img_6,
    organizer_img_1,
    organizer_img_2,
    organizer_img_3,
    organizer_img_4,
    organizer_img_5,
    organizer_img_6,
    organizer_img_7,
    organizer_img_8,
    testimonial_img_1,
    useNavigate,
    useDispatch,
    useSelector,
    Loader,
    moment,
    PerfectScrollbar,
    categoryList,
    eventByDate,
}